import { useState } from "react";

export const useModal = () => {
  const [visible, setVisible] = useState(false);
  const toggleDialog = () => setVisible(!visible);

  return { visible, onToggle: toggleDialog }
}